import React, { useEffect, useRef } from "react"

import CloudflarePlayer from "./cloudflare-player"
import { StreamPlayerApi } from "@cloudflare/stream-react"
import { cn } from "../../../shared/utils/cn"
import { useIntersectionObserver } from "usehooks-ts"

export enum VideoAspectRatio {
    "9/16" = "9/16",
    "16/9" = "16/9",
}

interface BackgroundVideoProps {
    id?: string
    aspectRatio: VideoAspectRatio
    className?: string
}

const BackgroundVideo = ({ id, className, aspectRatio }: BackgroundVideoProps) => {
    const player = useRef<StreamPlayerApi>()

    const { ref: freezedRef, isIntersecting: isFreezedIntersecting } = useIntersectionObserver({
        rootMargin: "1256px 256px 1256px 256px",
        freezeOnceVisible: true,
    })
    const { ref, isIntersecting } = useIntersectionObserver({
        rootMargin: "256px 256px 256px 256px",
    })

    useEffect(() => {
        if (!player.current) return

        if (!isIntersecting) {
            player.current.pause()
        } else {
            try {
                player.current.play()
            } catch (e) {
                player.current.muted = true
                player.current.play()
            }
        }
    }, [isIntersecting, player.current])

    if (!id) return null

    return (
        <div
            ref={node => {
                freezedRef(node)
                ref(node)
            }}
            className={cn(
                "relative h-full w-full child:absolute child:left-0 child:top-0 child:h-full child:w-full [&_iframe]:absolute [&_iframe]:left-1/2 [&_iframe]:top-1/2 [&_iframe]:-translate-x-1/2 [&_iframe]:-translate-y-1/2",
                {
                    "[&_iframe]:h-[max(calc(100dvh_-_var(--header-height)),56.25vw)] [&_iframe]:w-[max(100vw,177.78vh)]":
                        aspectRatio === "16/9",
                },
                {
                    "[&_iframe]:h-[max(calc(100dvh_-_var(--header-height)),177.78vw)] [&_iframe]:w-[max(100vw,56.25vh)]":
                        aspectRatio === "9/16",
                },
                className
            )}
        >
            {isFreezedIntersecting && <CloudflarePlayer id={id} streamRef={player} />}
        </div>
    )
}

export default BackgroundVideo
